<template>
  <div class="tcp-panel">
    <div v-if="loaded">
      <validation-observer ref="refFormObserver">
        <div class="tcp-header">
          <div class="tcp-header-icon">
            <i class="fas fa-home"></i>
          </div>
          <div>
            <div class="tcp-header-title">{{ msg('Generate contract') }}</div>
            <div class="tcp-header-sub">Treasure Home reservation</div>
          </div>
        </div>

        <!-- Toggles -->
        <div class="tcp-toggles">
          <div class="tcp-toggle-item">
            <label class="tcp-label">{{ msg('Export contract to channels') }}</label>
            <validation-provider #default="{ errors }" :name="msg('Client')" rules="required">
              <b-form-checkbox v-model="contract.hostawayApi" name="check-button" switch>
                {{ contract.hostawayApi ? msg('Yes') : msg('No') }}
              </b-form-checkbox>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </div>
          <div class="tcp-toggle-item">
            <label class="tcp-label">{{ msg('Paid') }}</label>
            <validation-provider #default="{ errors }" :name="msg('Paid')" rules="required">
              <b-form-checkbox v-model="contract.paid" name="check-button" switch>
                {{ contract.paid ? msg('Yes') : msg('No') }}
              </b-form-checkbox>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </div>
        </div>

        <!-- Form Fields -->
        <div class="tcp-section-label"><i class="fas fa-info-circle mr-50"></i> {{ msg('Contract Details') }}</div>
        <b-row class="tcp-form-grid">
          <b-col cols="12" md="6" lg="3">
            <div class="tcp-field">
              <label class="tcp-label">{{ msg('Client Id') }}</label>
              <validation-provider #default="{ errors }" :name="msg('Client')" rules="required">
                <client-picker v-model="contract.clientId"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12" md="6" lg="3">
            <div class="tcp-field">
              <label class="tcp-label">{{ msg('Property Id') }}</label>
              <validation-provider #default="{ errors }" :name="msg('Property')" rules="required">
                <real-estate-picker v-model="contract.propertyId"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12" md="6" lg="3">
            <div class="tcp-field">
              <label class="tcp-label">{{ msg('Start') }}</label>
              <validation-provider #default="{ errors }" :name="msg('Start date')" rules="required">
                <calendar-picker v-model="contract.bnbStyleRent.start"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12" md="6" lg="3">
            <div class="tcp-field">
              <label class="tcp-label">{{ msg('End') }}</label>
              <validation-provider #default="{ errors }" :name="msg('End date')" rules="required">
                <calendar-picker v-model="contract.bnbStyleRent.end"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12" md="6" lg="3">
            <div class="tcp-field">
              <label class="tcp-label">{{ msg('Price') }} (Bsp: 350.60)</label>
              <validation-provider #default="{ errors }" :name="msg('Price')" rules="required">
                <b-form-input type="number" v-model="contract.bnbStyleRent.totalPayment" class="tcp-input" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12" md="6" lg="2">
            <div class="tcp-field">
              <label class="tcp-label">{{ msg('Usage') }}</label>
              <validation-provider #default="{ errors }" :name="msg('Usage')" rules="required">
                <v-select :dir="isRTL ? 'rtl' : 'ltr'" v-model="contract.use" :options="[{value:'PRIVATE',label:msg('Private use')},{value:'COMMERCIAL',label:msg('Commercial use')}]" label="label" :reduce="(s) => s.value" class="w-100 tcp-select" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12" md="6" lg="2">
            <div class="tcp-field">
              <label class="tcp-label">{{ msg('Number of guests') }}</label>
              <validation-provider #default="{ errors }" :name="msg('Number of guests')" rules="required">
                <b-form-input type="number" v-model="contract.numberOfGuests" class="tcp-input" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12" md="6" lg="3">
            <div class="tcp-field">
              <label class="tcp-label">{{ msg('Platform') }}</label>
              <validation-provider #default="{ errors }" :name="msg('Platform')" rules="required">
                <v-select :dir="isRTL ? 'rtl' : 'ltr'" v-model="contract.bnbStyleRent.platform" :options="[{value:'Booking',label:msg('Booking')},{value:'Airbnb',label:msg('Airbnb')},{value:'Treasure Home',label:msg('Treasure Home')},{value:'Expedia',label:msg('Expedia')},{value:'Vrbo',label:msg('Vrbo')},{value:'Agoda',label:msg('Agoda')},{value:'Sonstige Plattform',label:msg('Sonstige Plattform')}]" label="label" :reduce="(s) => s.value" class="w-100 tcp-select" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12" md="6" lg="2">
            <div class="tcp-field">
              <label class="tcp-label">{{ msg('Language') }}</label>
              <validation-provider #default="{ errors }" :name="msg('Language')" rules="required">
                <v-select :dir="isRTL ? 'rtl' : 'ltr'" v-model="contract.language" :options="languageOptions" label="name" :reduce="o => o.id" class="w-100 tcp-select" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </b-col>
        </b-row>
      </validation-observer>
    </div>
    <div v-else-if="this.error != null">
      <div class="tcp-error">
        <i class="fas fa-exclamation-triangle mr-75"></i>
        <strong>{{ error }}</strong>
      </div>
    </div>
    <div v-else class="tcp-loading">
      <b-spinner variant="primary" />
      <span class="ml-75">{{ msg('loading') }}</span>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import ClientPicker from "@/components/components/picker/clientPicker";
import RealEstatePicker from "@/components/components/picker/realEstatesPicker";

const initContract = () => ({
  hostawayApi: true, name: '', propertyId: null, clientId: null,
  bnbStyleRent: {
    platform: null, active: true,
    start: null, end: null, totalPayment: 0.0, oneTimePayment: false,
    totalPaymentDiscount: null, totalServiceFee: null, totalPriceHandlingFee: null,
  },
  type: null,
});

export default {
  name: 'treasureContractRentPanel',
  components: {RealEstatePicker, ClientPicker},
  data() {
    return {
      loaded: false,
      error: null,
      contractId: 0,
      contract: initContract(),
      languageOptions: [
        {id: 'EN', name: 'English'},
        {id: 'ES', name: 'Spanish'},
        {id: 'FR', name: 'French'},
        {id: 'DE', name: 'German'},
        {id: 'IT', name: 'Italian'},
        {id: 'PT', name: 'Portuguese'},
        {id: 'RU', name: 'Russian'},
        {id: 'CN', name: 'Chinese'},
        {id: 'JP', name: 'Japanese'}
      ],
      listeners: {
        submit: () => {
        }
      }
    }
  },
  computed: {
    ...mapGetters('realEstate', ['getAllTypes']),
  },
  created() {
    this.onLoad()
    this.$root.$on('crm::submitContract', (this.listeners.submit = () => {
      this.submit()
    }))
  },
  beforeDestroy() {
    this.$root.$off('crm::submitContract', this.listeners.submit)
  },
  methods: {
    ...mapActions('realEstateContracts', {_createContract: 'createContract',}),
    onLoad() {
      this.contract = initContract();
      this.loaded = true
    },
    setData(propertyId, start, end){
      this.contract.propertyId = propertyId
      this.contract.bnbStyleRent.start = start
      this.contract.bnbStyleRent.end = end
      this.loaded = true
    },
    createContract() {
      let $this = this
      if (this.contract.paid == null)
        this.contract.paid = false
      this.$refs['refFormObserver'].validate().then(valid => {
        if (!valid)
          return;
        $this._createContract(this.contract)
            .then(
                (id) => {
                  $this.contractId = id
                  $this.$emit('submitted', {
                    status: true,
                    server: id,
                    id
                  })
                },
                (a) => $this.$emit('submitted', {
                  status: false,
                  server: a
                })
            )
            .finally(() => {
              if ($this.contractId != null && $this.contractId !== 0&& $this.contractId !== 'success'&& !$this.contractId.contains('Error'))
                this.$router.push(`/real_estate/contracts/rent/${$this.contractId}`);
            })
      })
    },
    validate(field) {
      return this.$v.contract[field] != null && this.$v.contract[field].$error === true
    },
    submit() {
      return this.createContract()
    }
  },
}
</script>

<style scoped>
.tcp-panel { padding: 8px; }
.tcp-header { display: flex; align-items: center; gap: 12px; margin-bottom: 20px; }
.tcp-header-icon { width: 44px; height: 44px; border-radius: 14px; display: flex; align-items: center; justify-content: center; background: rgba(0,184,148,.12); color: #00b894; font-size: 18px; flex-shrink: 0; }
.tcp-header-title { font-weight: 900; font-size: 16px; }
.tcp-header-sub { font-size: 12px; opacity: .6; }
.tcp-toggles { display: flex; gap: 24px; padding: 14px 18px; border-radius: 14px; background: rgba(0,0,0,.02); border: 1px solid rgba(0,0,0,.06); margin-bottom: 20px; flex-wrap: wrap; }
.tcp-toggle-item { min-width: 140px; }
.tcp-section-label { font-weight: 800; font-size: 12px; text-transform: uppercase; letter-spacing: .5px; margin-bottom: 14px; color: #7367f0; display: flex; align-items: center; }
.tcp-form-grid { row-gap: 8px; }
.tcp-field { margin-bottom: 8px; }
.tcp-label { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px; opacity: .65; margin-bottom: 4px; display: block; }
.tcp-input { border-radius: 10px; }
.tcp-select :deep(.vs__dropdown-toggle) { border-radius: 10px; }
.tcp-error { padding: 16px; border-radius: 14px; background: rgba(234,84,85,.08); border: 1px solid rgba(234,84,85,.2); color: #ea5455; }
.tcp-loading { display: flex; align-items: center; justify-content: center; min-height: 200px; opacity: .7; }
</style>
